<div
  [atxPopover]="popoverContent"
  [autoClose]="autoClose"
  [backdropClass]="backdropClass"
  [closeOnScroll]="closeOnScroll"
  [componentClass]="componentClass"
  [hasBackdrop]="hasBackdrop"
  [panelClass]="panelClass"
  [popoverPlacement]="popoverPlacement"
  [stickWithFullWidth]="stickWithFullWidth"
  [triggers]="triggers"
>
  <epc-dynamic-collections-renderer
    [items]="dynamicTriggerContentItems"
    [parent]="this"
    [scope]="scope"
    class="d-contents"
  >
  </epc-dynamic-collections-renderer>
</div>

<ng-template #popoverContent>
  <epc-dynamic-collections-renderer
    [items]="dynamicPopoverContentItems"
    [parent]="this"
    [scope]="scope"
    class="d-contents"
  >
  </epc-dynamic-collections-renderer>
</ng-template>
